var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_81621_17613)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49657 9.92969C9.96238 9.92969 11.9609 7.9302 11.9609 5.46438C11.9609 2.99856 9.96238 1 7.49657 1C5.03076 1 3.03128 2.99856 3.03128 5.46438C3.02295 7.92187 5.00855 9.92136 7.46511 9.92969H7.49657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50046 11C3.72455 11 0.5 11.6968 0.5 14.4875C0.5 17.2782 3.70409 18 7.50046 18C9.69502 18 11.703 17.7642 13 17.0191V12.457C12.75 12.293 12.3008 11.875 12.1188 11.5932C10.8762 11.1538 9.25145 11 7.50046 11Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5133 9.13481C18.5152 8.5781 18.3676 8.03108 18.0859 7.55091C17.8042 7.07075 17.3987 6.67507 16.9117 6.40521C16.4248 6.13535 15.8744 6.00123 15.3179 6.01685C14.7614 6.03247 14.2193 6.19727 13.7483 6.49402C13.2773 6.79077 12.8946 7.20858 12.6403 7.70379C12.3859 8.199 12.2692 8.75344 12.3024 9.30916C12.3356 9.86489 12.5174 10.4015 12.8289 10.8629C13.1403 11.3244 13.57 11.6937 14.073 11.9323V16.6835L15.4051 18.0156L17.6252 15.7954L16.2931 14.4633L17.6252 13.1312L16.524 12.03C17.1089 11.8043 17.6118 11.407 17.9668 10.8903C18.3218 10.3737 18.5123 9.7617 18.5133 9.13481ZM15.4051 9.13481C15.2294 9.13481 15.0577 9.08272 14.9117 8.98514C14.7657 8.88755 14.6518 8.74885 14.5846 8.58658C14.5174 8.4243 14.4998 8.24574 14.5341 8.07347C14.5683 7.9012 14.6529 7.74296 14.7771 7.61876C14.9013 7.49456 15.0596 7.40997 15.2318 7.37571C15.4041 7.34144 15.5826 7.35903 15.7449 7.42624C15.9072 7.49346 16.0459 7.60729 16.1435 7.75333C16.2411 7.89938 16.2931 8.07108 16.2931 8.24672C16.2931 8.48226 16.1996 8.70815 16.033 8.87469C15.8665 9.04124 15.6406 9.13481 15.4051 9.13481Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_81621_17613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserKey);
export default __webpack_public_path__ + "static/media/user-key.72d4f0b283204a3fd0935ae2a5cc4c9e.svg";
export { ForwardRef as ReactComponent };